import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';
import UserTable from '../../components/UserTable';
import UserModal from '../../components/UserModal';

export default function Users() {
  const [user, setUser] = React.useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null); // NEW: Track editing user
  const [refreshKey, setRefreshKey] = useState(0);
  const [allInitials, setAllInitials] = useState([]);

  React.useEffect(() => {
    getUserInfo().then(setUser);
  }, []);

  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;

  // NEW: Handle edit click
  const handleEditClick = (userToEdit) => {
    console.log('Editing user roles:', userToEdit.roles); // Log user roles to the console
    setEditingUser(userToEdit);
    setModalOpen(true);
  };

  // NEW: Handle modal close
  const handleModalClose = () => {
    setModalOpen(false);
    setEditingUser(null); // Clear editing user when closing
  };

  // NEW: Handle user updated
  const handleUserUpdated = () => {
    setModalOpen(false);
    setEditingUser(null);
    setRefreshKey(k => k + 1); // Refresh the table
  };

  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-4">Users</h1>

      <UserTable
        key={refreshKey}
        onCreateClick={() => setModalOpen(true)}
        onEditClick={handleEditClick} // NEW: Pass edit handler
        onUsersLoaded={users => setAllInitials(users.map(u => u.initials?.toUpperCase()).filter(Boolean))}
      />
      <UserModal
        open={modalOpen}
        onClose={handleModalClose} // Use new handler
        onCreated={() => { setModalOpen(false); setRefreshKey(k => k + 1); }}
        onUpdated={handleUserUpdated} // NEW: Handle user updates
        editingUser={editingUser} // NEW: Pass editing user data
        existingInitials={allInitials}
      />
    </Layout>
  );
}
